/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offers_BuyInputs */

const en_offers_buy = /** @type {(inputs: Offers_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy`)
};

const pl_offers_buy = /** @type {(inputs: Offers_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kup`)
};

/**
* | output |
* | --- |
* | "Buy" |
*
* @param {Offers_BuyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_buy = /** @type {((inputs?: Offers_BuyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_BuyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_buy(inputs)
	return en_offers_buy(inputs)
});